module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/iPhone-back-bdb1af30162d99b9c7e01b5ac26deef5.svg";